import { render } from "./Marquee.vue?vue&type=template&id=638e056f&scoped=true"
import script from "./Marquee.vue?vue&type=script&lang=js"
export * from "./Marquee.vue?vue&type=script&lang=js"

import "./Marquee.vue?vue&type=style&index=0&id=638e056f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638e056f"]])

export default __exports__